import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TextField from '@mui/material/TextField';
import { connect } from 'react-redux';
import setTextAccDescriptionAction from '../../redux/actions/createReferenceActions/actionDecription';
import setTextAccCommentAction from '../../redux/actions/createReferenceActions/actionComment';
import setTextAccCommentPlanerAction from '../../redux/actions/createReferenceActions/actionCommentPlaner';
import setTextAccCommentOwnerAction from '../../redux/actions/createReferenceActions/actionCommentOwner';
import setTextAccLongDescriptionAction from '../../redux/actions/createReferenceActions/actionLongDescription';
import { withTranslation } from 'react-i18next';



class TextAccordion extends React.Component {
    constructor(props) {
        super(props);

        if (this.props.selectedReferenceData && window.location.href.indexOf('/editRef') > -1) {
            this.state = {
                description: this.props.selectedReferenceData.description,
                longDescription: this.props.selectedReferenceData.long_description,
                commentCont: this.props.selectedReferenceData.comment_contactor,
                commentPlaner: this.props.selectedReferenceData.comment_planer,
                commentOwner: this.props.selectedReferenceData.comment_owner,
                accWidth: 300, matches: window.matchMedia("(min-width: 768px)").matches,
                accExpandet: false
            }
            this.props.setTextDecriptionFunction(this.state.description)
            this.props.setTextLongDecriptionFunction(this.state.longDescription)
            this.props.setTextAccCommentConFunction(this.state.commentCont)
            this.props.setTextAccCommentPlanerFunction(this.state.commentPlaner)
            this.props.setTextAccCommentOwnerFunction(this.state.commentOwner)
        } else {
            this.state = {
                description: '',
                longDescription: '',
                commentCont: '',
                commentPlaner: '',
                commentOwner: '',
                ccWidth: 300,
                accExpandet: false,
                matches: window.matchMedia("(min-width: 768px)").matches
            };
            this.props.setTextDecriptionFunction('defaultDesription')
            this.props.setTextAccCommentConFunction('defaultComment')
            this.props.setTextAccCommentPlanerFunction('defaultComment')
            this.props.setTextAccCommentOwnerFunction('defaultComment')
            this.props.setTextLongDecriptionFunction('defaultLongDescription')
        }

        this.handleChangeDescription = this.handleChangeDescription.bind(this);
        this.handleChangeCommentContractor = this.handleChangeCommentContractor.bind(this);
        this.handleChangeCommentPlaner = this.handleChangeCommentPlaner.bind(this);
        this.handleChangeCommentOwner = this.handleChangeCommentOwner.bind(this);
        this.handleChangeLongDescription = this.handleChangeLongDescription.bind(this);
        this.handleAccordion = this.handleAccordion.bind(this);
    }

    componentDidMount() {
        const handler = e => this.setState({ matches: e.matches });
        window.matchMedia("(min-width: 768px)");
        this.setState({ accWidth: 300 })
    }

    handleAccordion() {

        this.setState({ accExpandet: this.state.accExpandet ? false : true })

        if (!this.state.matches) {
            this.setState({ accWidth: 300 })
        } else {
            // this.setState({accWidth: 300})
            if (this.state.accExpandet) {
                this.setState({ accWidth: 300 })
            } else {
                this.setState({ accWidth: '387pt' })
            }
        }
    }

    handleChangeDescription(event, value) {

        this.setState({ description: event.target.value }, () => {
            this.props.setTextDecriptionFunction(this.state.description);
            // console.log(this.state.description);
        });
    }

    handleChangeLongDescription(event, value) {
        this.setState({ longDescription: event.target.value }, () => {
            this.props.setTextLongDecriptionFunction(this.state.longDescription);
            // console.log(this.state.description);
        });
    }

    handleChangeCommentContractor = (event) => {
        this.setState({ commentCont: event.target.value }, () => {
            this.props.setTextAccCommentConFunction(this.state.commentCont);
            // console.log(this.state.comment);
        });
    }

    handleChangeCommentPlaner = (event) => {
        this.setState({ commentPlaner: event.target.value }, () => {
            this.props.setTextAccCommentPlanerFunction(this.state.commentPlaner);
            // console.log(this.state.comment);
        });
    }

    handleChangeCommentOwner = (event) => {
        this.setState({ commentOwner: event.target.value }, () => {
            this.props.setTextAccCommentOwnerFunction(this.state.commentOwner);
            // console.log(this.state.comment);
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div >
                <Accordion onChange={this.handleAccordion} expanded={this.state.accExpandet} style={{ 
                    width: this.state.accWidth, backgroundColor: 'rgba(19, 174, 236, 0.54)',  border: this.props.descriptionError ? '1px solid red' : 'none' }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography>{t("create_ref.textaccordion_add_description")}</Typography>
                    </AccordionSummary>
                    <AccordionDetails style={{ width: '100%', marginBottom: 10, padding: 0, backgroundColor: 'rgba(19, 174, 236, 0.54)' }}>
                        <TextField style={{ width: '100%' }}
                            onChange={this.handleChangeDescription}
                            id="outlined-multiline"
                            label={t("create_ref.textaccordion_description")}
                            multiline
                            rows={4}
                            variant="outlined"
                            inputProps={{ maxLength: 699 }}
                            error={this.props.descriptionError}
                            sx={{
                                "&:hover ": {
                                    borderColor: "rgb(0,191,255)"
                                },
                                '& label.Mui-focused': {
                                    color: 'white'
                                },
                                "& .Mui-focused ": {
                                    color: 'white'
                                },
                                '& .MuiOutlinedInput-root': {

                                    '&:hover fieldset': {
                                        borderColor: 'rgb(0,191,255)',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: 'rgb(47, 79, 79)',
                                    },
                                },
                            }}
                            value={this.state.description !== null ? this.state.description : ''}
                        />
                    </AccordionDetails>
                    {/* Savarin 17.06.2025: lange Beschreibung rausnehmen i.A. von Herrn Moysidis*/}
                    {/* <AccordionDetails style={{ width: '100%', marginBottom: 10, padding: 0, backgroundColor: 'rgba(19, 174, 236, 0.54)' }}>
                        <TextField style={{ width: '100%' }}
                            onChange={this.handleChangeLongDescription}
                            id="outlined-multiline"
                            label={t("create_ref.textaccordion_long_description")}
                            multiline
                            rows={4}
                            variant="outlined"
                            inputProps={{ maxLength: 4999 }}
                            sx={{
                                "&:hover ": {
                                    borderColor: "rgb(0,191,255)"
                                },
                                '& label.Mui-focused': {
                                    color: 'white'
                                },
                                "& .Mui-focused ": {
                                    color: 'white'
                                },
                                '& .MuiOutlinedInput-root': {

                                    '&:hover fieldset': {
                                        borderColor: 'rgb(0,191,255)',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: 'rgb(47, 79, 79)',
                                    },
                                },
                            }}
                            value={this.state.longDescription !== null ? this.state.longDescription : ''}
                        />
                    </AccordionDetails> */}
                    <AccordionDetails style={{ width: '100%', marginBottom: 10, padding: 0, backgroundColor: 'rgba(19, 174, 236, 0.54)' }}>
                        <TextField style={{ width: '100%' }}
                            onChange={this.handleChangeCommentContractor}
                            id="outlined-multiline"
                            label={t("create_ref.textaccordion_contactor")}
                            multiline
                            rows={3}
                            variant="outlined"
                            inputProps={{ maxLength: 70 }}
                            sx={{
                                "&:hover ": {
                                    borderColor: "rgb(0,191,255)"
                                },
                                '& label.Mui-focused': {
                                    color: 'white'
                                },
                                "& .Mui-focused ": {
                                    color: 'white'
                                },
                                '& .MuiOutlinedInput-root': {

                                    '&:hover fieldset': {
                                        borderColor: 'rgb(0,191,255)',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: 'rgb(47, 79, 79)',
                                    },
                                },
                            }}
                            value={this.state.commentCont !== null ? this.state.commentCont : ''}
                        />
                    </AccordionDetails>
                    <AccordionDetails style={{ width: '100%', marginBottom: 10, padding: 0, backgroundColor: 'rgba(19, 174, 236, 0.54)' }}>
                        <TextField style={{ width: '100%' }}
                            onChange={this.handleChangeCommentPlaner}
                            id="outlined-multiline-static"
                            label={t("create_ref.textaccordion_planer")}
                            multiline
                            rows={3}
                            variant="outlined"
                            inputProps={{ maxLength: 70 }}
                            sx={{
                                "&:hover ": {
                                    borderColor: "rgb(0,191,255)"
                                },
                                '& label.Mui-focused': {
                                    color: 'white'
                                },
                                "& .Mui-focused ": {
                                    color: 'white'
                                },
                                '& .MuiOutlinedInput-root': {

                                    '&:hover fieldset': {
                                        borderColor: 'rgb(0,191,255)',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: 'rgb(47, 79, 79)',
                                    },
                                },
                            }}
                            value={this.state.commentPlaner !== null ? this.state.commentPlaner : ''}
                        />
                    </AccordionDetails>
                    <AccordionDetails style={{ width: '100%', marginBottom: 0, padding: 0, backgroundColor: 'rgba(19, 174, 236, 0.54)' }}>
                        <TextField style={{ width: '100%' }}
                            onChange={this.handleChangeCommentOwner}
                            id="outlined-multiline-static"
                            label={t("create_ref.textaccordion_owner")}
                            multiline
                            rows={3}
                            variant="outlined"
                            inputProps={{ maxLength: 70 }}
                            sx={{
                                "&:hover ": {
                                    borderColor: "rgb(0,191,255)"
                                },
                                '& label.Mui-focused': {
                                    color: 'white'
                                },
                                "& .Mui-focused ": {
                                    color: 'white'
                                },
                                '& .MuiOutlinedInput-root': {

                                    '&:hover fieldset': {
                                        borderColor: 'rgb(0,191,255)',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: 'rgb(47, 79, 79)',
                                    },
                                },
                            }}
                            value={this.state.commentOwner !== null ? this.state.commentOwner : ''}
                        />
                    </AccordionDetails>
                </Accordion>

                <h6 style={{ color: 'white', marginTop: 10 }}>{t("create_ref.textaccordion_mandatory")}</h6>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedReferenceData: state.showRefState.selectedReferenceData,
        descriptionError: state.createRefState.descriptionError
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setTextDecriptionFunction: (description) => {
            dispatch(setTextAccDescriptionAction(description))
        },
        setTextLongDecriptionFunction: (longDescription) => {
            dispatch(setTextAccLongDescriptionAction(longDescription))
        },
        setTextAccCommentConFunction: (commentCont) => {
            dispatch(setTextAccCommentAction(commentCont))
        },

        setTextAccCommentPlanerFunction: (commentPlaner) => {
            dispatch(setTextAccCommentPlanerAction(commentPlaner))
        },

        setTextAccCommentOwnerFunction: (commentOwner) => {
            dispatch(setTextAccCommentOwnerAction(commentOwner))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TextAccordion));